/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import GetPayHistoryActionBox from '../ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import EmployeeNamePic from '../EmployeeNamePic/EmployeeNamePic';
import './tables_styles.css';
import LeaveARModalController from '../../Modals/ActionRequiredModals/LeaveARModal/LeaveARModalController';
import { useAppSelector } from '../../../infra/hooks';
import _ from 'lodash';
import { actionRequiredService } from '../../../api/services/actionRequiredService';
import { arabicDataGrid, baseDateFormatting } from '../../helper';
import { useTranslate } from '../../../hooks';
import { DateField } from '../../../components';
interface Propval {
  trans: any;
}

const LeavesTable = ({ trans }: Propval) => {
  const [openModal, setOpenModal] = useState(false);
  const [leaveHistory, setLeaveHistory] = useState([]);
  const [leaveInsight, setLeaveInsight] = useState([]);
  const [canAct, setCanAct] = useState(false);

  //main state for handling data
  const [fullData, setFullData] = useState(null);
  const storedARData = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredData,
  );
  const selector = useAppSelector((state) => state);
  const tableColumns: any = [
    {
      field: 'empId',
      headerName: trans('Emp Id'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'empName',
      headerName: trans('Emp Name'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return <EmployeeNamePic name={params?.row?.empName} picture="" />;
      },
    },
    {
      field: 'leaveType',
      headerName: trans('Leave Type'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'appliedOn',
      headerName: trans('Applied On'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return params?.row?.appliedOn ? (
          <DateField
            value={params?.row?.appliedOn}
            offset={0}
            format={baseDateFormatting}
          />
        ) : (
          '--'
        );
      },
    },
    {
      field: 'from',
      headerName: trans('From'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return params?.row?.from ? (
          <DateField
            value={params?.row?.from}
            format={baseDateFormatting}
            offset={0}
          />
        ) : (
          '--'
        );
      },
    },
    {
      field: 'to',
      headerName: trans('To'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return params?.row?.to ? (
          <DateField
            value={params?.row?.to}
            format={baseDateFormatting}
            offset={0}
          />
        ) : (
          '=='
        );
      },
    },
    {
      field: 'days',
      headerName: trans('Days'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'reasons',
      headerName: trans('Reasons'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'status',
      headerName: trans('Status'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              handleLeaveView(params?.row?.fullData);
              setOpenModal(true);
            }}
          />
        );
      },

      height: 70,
    },
  ];

  const handleLeaveView = (x: any) => {
    if (x) {
      actionRequiredService
        .getLeaveHistory(x?.emp_id, x?.company_id)
        .then((res) => {
          if (res?.response == 'success') {
            setLeaveHistory(res?.data);
          }
        })
        .catch(() => console.log('error', 'err getting leaves'));

      actionRequiredService
        .getLeaveInsight(x.department_id, x.start_date, x.end_date)
        .then((res) => {
          if (res?.response == 'success') setLeaveInsight(res?.data);
        })
        .catch((err) => {
          console.log('error', err);
        });
      actionRequiredService
        .getStepActions(x.current_step_id, x.workflow_id)

        .catch(() => {
          console.log('error');
        });
    }
    setFullData(x);
    canTakeAction(x.step.id);
  };
  const canTakeAction = (step_id: any) => {
    const step = step_id;

    actionRequiredService
      .userCanActOnStep(
        selector.authSlice.user_id,
        selector.authSlice.company_id,
        step,
        selector.authSlice.emp_id,
      )
      .then((response) => {
        setCanAct(response);
      })
      .catch(() => {
        setCanAct(false);
      });
  };

  const getStatus = ['Pending', 'Approved', 'Rejected'];

  const row_data = _.map(storedARData, (data: any) => {
    // Calculate the difference in days
    return {
      id: data?.id,
      empId: `#${data?.staff_id}`,
      empName: `${data?.first_name} ${data?.last_name}`,
      empPic: data?.profile_pic,
      leaveType: data?.leaveType,
      appliedOn: data?.applied_on,
      from: data?.start_date,
      to: data?.end_date,
      days: data?.total_leave_days,
      reasons: data?.leave_reason,
      status:getStatus[data?.status],
      fullData: data,
    };
  });

  const { isRTL } = useTranslate();

  return (
    <>
      <Box
        className="ar_table"
        sx={{
          '& .header': {
            backgroundColor: '#F5F5F5',
          },

          width: '100%',
          marginTop: '2em',
        }}
      >
        <DataGrid
          sx={{
            color: '#081735',
            font: 'normal normal normal 14px/24px Lato;',
          }}
          autoHeight
          localeText={isRTL ? arabicDataGrid : undefined}
          disableExtendRowFullWidth
          disableSelectionOnClick
          disableColumnMenu
          disableColumnFilter
          rows={row_data}
          columns={tableColumns}
        />
      </Box>
      {openModal && (
        <LeaveARModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          leave_data={fullData}
          leaveHistory={leaveHistory}
          leaveInsight={leaveInsight}
          canAct={canAct}
        />
      )}
    </>
  );
};

export default LeavesTable;
